import React, { useState, useEffect } from 'react';
import { Card, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import PageHeader1 from '../../components/common/PageHeader1';
import EditButton from "../../components/common/EditButton";
import DeleteButton from "../../components/common/DeleteButton";
import apiClient from "../../utils/api";

const mockSMSSettings = [
    {
        id: 1,
        api_key: "sk_test_51HG7dkLkj3mK9pQw8xJ2N5Vy",
        sms_template: "Your car with ticket {ticket_number} is ready for pickup. Total amount: ${amount}. Pay online: {payment_url}",
        enable_payment_url: true,
        mobile_required: true,
        created_at: "2024-01-15T10:30:00",
        updated_at: "2024-01-15T10:30:00"
    },
    {
        id: 2,
        api_key: "sk_live_51HG7dkLkj3mK9pRx9zL4P6Tm",
        sms_template: "VIP Parking Service - Your vehicle (Ticket: {ticket_number}) has been safely parked. Amount due: ${amount}",
        enable_payment_url: false,
        mobile_required: true,
        created_at: "2024-01-16T11:45:00",
        updated_at: "2024-01-16T11:45:00"
    },
    {
        id: 3,
        api_key: "sk_test_51HG7dkLkj3mK9pSy7wB5R8Un",
        sms_template: "Pickup ready for ticket {ticket_number}. Fee: ${amount}. Quick pay: {payment_url}. Thank you for choosing our service!",
        enable_payment_url: true,
        mobile_required: false,
        created_at: "2024-01-17T14:20:00",
        updated_at: "2024-01-17T14:20:00"
    },
    {
        id: 4,
        api_key: "sk_live_51HG7dkLkj3mK9pTz5xD3M2Kq",
        sms_template: "Welcome to Premium Valet! Your ticket: {ticket_number}. Services charges will be calculated at pickup.",
        enable_payment_url: false,
        mobile_required: true,
        created_at: "2024-01-18T09:15:00",
        updated_at: "2024-01-18T09:15:00"
    },
    {
        id: 5,
        api_key: "sk_test_51HG7dkLkj3mK9pUw3vF1L4Hm",
        sms_template: "🚗 Your valet ticket: {ticket_number}. Amount: ${amount}. Secure payment link: {payment_url}. Have a great day!",
        enable_payment_url: true,
        mobile_required: true,
        created_at: "2024-01-19T16:30:00",
        updated_at: "2024-01-19T16:30:00"
    }
];

function SMSSettingsList() {
    const [settings, setSettings] = useState([]);

    useEffect(() => {
        fetchSettings();
    }, []);

    const fetchSettings = async () => {
        try {
            const token = localStorage.getItem('auth_token');
            const response = await apiClient.get('accounts/sms-settings', {
                headers: { Authorization: `Bearer ${token}` }
            });
            setSettings(response.data.data);
        } catch (error) {
            console.error('Error:', error);
            toast.error('Error loading SMS settings');
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Are you sure you want to delete this setting?')) {
            return;
        }
        try {
            const token = localStorage.getItem('auth_token');
            await apiClient.delete(`accounts/sms-settings/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            toast.success('Setting deleted successfully');
            fetchSettings();
        } catch (error) {
            console.error('Error:', error);
            toast.error('Error deleting setting');
        }
    };

    const handleTest = async (id) => {
        try {
            const token = localStorage.getItem('auth_token');
            await apiClient.post(`accounts/sms-settings/${id}/test`, {}, {
                headers: { Authorization: `Bearer ${token}` }
            });
            toast.success('Test SMS sent successfully');
        } catch (error) {
            console.error('Error:', error);
            toast.error('Failed to send test SMS');
        }
    };

    return (
        <div className="body d-flex py-3">
            <div className="container-xxl">
                <PageHeader1 
                    pagetitle='SMS Settings' 
                    righttitle='Add Setting'
                    link='/accounts/sms-settings/add'
                    routebutton={true}
                />
                <Card>
                    <Card.Body>
                        <Table responsive striped hover>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>API Key</th>
                                    <th>SMS Template</th>
                                    <th>Payment URL</th>
                                    <th>Mobile Required</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {settings.map((setting) => (
                                    <tr key={setting.id}>
                                        <td>{setting.id}</td>
                                        <td>{setting.api_key.substring(0, 10)}...</td>
                                        <td>{setting.sms_template.substring(0, 30)}...</td>
                                        <td>{setting.enable_payment_url ? 'Yes' : 'No'}</td>
                                        <td>{setting.mobile_required ? 'Yes' : 'No'}</td>
                                        <td>
                                            <div className="btn-group" role="group">
                                                <EditButton
                                                    to={`${process.env.PUBLIC_URL}/accounts/sms-settings/edit/${setting.id}`}
                                                    className="btn btn-outline-secondary"
                                                    title="Edit Setting"
                                                >
                                                    <i className="fa fa-edit"></i>
                                                </EditButton>
                                                <DeleteButton
                                                    onDelete={() => handleDelete(setting.id)}
                                                    className="btn btn-outline-danger"
                                                    title="Delete Setting"
                                                >
                                                    <i className="fa fa-trash"></i>
                                                </DeleteButton>
                                                <button 
                                                    type="button"
                                                    className="btn btn-outline-info"
                                                    onClick={() => window.open(`/accounts/sms-preview/${setting.id}`, '_blank')}
                                                    title="Preview Template"
                                                >
                                                    <i className="fa fa-eye"></i>
                                                </button>
                                                <button 
                                                    type="button"
                                                    className="btn btn-outline-success"
                                                    onClick={() => handleTest(setting.id)}
                                                    title="Test SMS"
                                                >
                                                    <i className="fa fa-paper-plane"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
            </div>
        </div>
    );
}

export default SMSSettingsList;